import './App.css';
import './test.scss';
import { Project } from './Project/Project';

function App() {
  return (
    <div className="App">
        <Project/>
    </div>
  );
}



export default App;
